import { Injectable, signal } from '@angular/core';
import { JwtService } from '../jwt/jwt.service';

interface UserProfile {
  username: string;
  roleName?: string;
  isApprovedAttorney: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private readonly userProfile = signal<UserProfile | null>(null);

  constructor(private readonly jwtService: JwtService) {
    this.initializeProfile();
  }

  private initializeProfile(): void {
    const token = this.getTokenFromStorage();
    if (token) {
      try {
        const decodedToken = this.jwtService.getTokenPayload(token);
        if (decodedToken) {
          const tokenData = decodedToken as any;
          const roleName = tokenData.roleName;
          const isApprovedAttorney = roleName === 'ID Verification Access Only';
          
          this.userProfile.set({
            username: tokenData.username || '',
            roleName,
            isApprovedAttorney
          });
        } else {
          this.userProfile.set(null);
        }
      } catch (error) {
        this.userProfile.set(null);
      }
    }
  }

  get userProfileSignal() {
    return this.userProfile;
  }

  get username(): string {
    return this.userProfile()?.username || '';
  }

  get isApprovedAttorney(): boolean {
    return this.userProfile()?.isApprovedAttorney || false;
  }

  getTokenFromStorage(): string | null {
    // Use localStorage for token storage
    return localStorage.getItem('access_token');
  }

  refreshProfile(): void {
    this.initializeProfile();
  }
} 